import React from "react";
import InfoSection from "@components/pages/info/info_section";

function ServiceNumber() {
    return (
        <InfoSection title="Meðferð persónuupplýsinga">
            <p>
                &Iacute; skilm&aacute;lum &thorn;essum merkja pers&oacute;nuuppl&yacute;singar
                s&eacute;rhverjar pers&oacute;nugreindar e&eth;a pers&oacute;nugreinanlegar
                uppl&yacute;singar um notanda sem notandi l&aelig;tur af hendi e&eth;a
                s&iacute;mf&eacute;l&ouml;g hafa &iacute; s&iacute;num f&oacute;rum og l&aacute;ta
                af hendi til 1819 vegna &thorn;eirrar &thorn;j&oacute;nustu sem 1819 veitir.
            </p>
            <p>
                Hj&aacute; 1819 fer fram s&ouml;fnun og vinnsla &aacute;
                pers&oacute;nuuppl&yacute;singum sem gegna &thorn;eim tilgangi a&eth; veita
                &nbsp;grunn uppl&yacute;singar til vi&eth;skiptavina 1819.
            </p>
            <p>
                Me&eth; vinnslu er &aacute;tt vi&eth; hvers konar a&eth;ger&eth; e&eth;a
                r&ouml;&eth; a&eth;ger&eth;a &thorn;ar sem unni&eth; er me&eth;
                pers&oacute;nuuppl&yacute;singar, hvort sem vinnslan er handvirk e&eth;a
                rafr&aelig;n. Af &thorn;v&iacute; lei&eth;ir a&eth; notandi hefur sam&thorn;ykkt
                a&eth; 1819 s&eacute; heimilt a&eth; birta uppl&yacute;singar, mi&eth;la &thorn;eim
                og vinna &thorn;&aelig;r me&eth; &thorn;eim h&aelig;tti sem 1819 telur
                nau&eth;synlegt.
            </p>
            <p>
                Vi&eth; vinnslu pers&oacute;nuuppl&yacute;singa telst 1819, N&yacute;r valkostur ehf
                &aacute;byrg&eth;ara&eth;ili &iacute; skilningi laga um pers&oacute;nuvernd og
                me&eth;fer&eth; pers&oacute;nuuppl&yacute;singa, nr. 90/2018. Vakin er athygli
                notanda &aacute; uppl&yacute;singar&eacute;tti hans skv. 13, 14 og 15 gr. laganna og
                r&eacute;tti hans til a&eth; uppl&yacute;singar um hann ver&eth;i
                lei&eth;r&eacute;ttar e&eth;a &thorn;eim eytt. Pers&oacute;nugreinanlegar
                uppl&yacute;singar eru a&eth;eins vista&eth;ar &iacute; gagnagrunni 1819 svo lengi
                sem vi&eth;skiptavinir &oacute;ska eftir en eytt eigi s&iacute;&eth;ar en 90
                d&ouml;gum eftir a&eth; &thorn;eir eru skr&aacute;&eth;ir &uacute;r
                &thorn;j&oacute;nustunni, e&eth;a &oacute;ska eftir a&eth; uppl&yacute;singum
                s&eacute; eytt. Uppl&yacute;singum um l&aacute;tna einstaklinga er eytt eigi
                s&iacute;&eth;ar en 90 d&ouml;gum eftir a&eth; skr&aacute;ning &thorn;eirra er
                &oacute;virk &iacute; &thorn;j&oacute;&eth;skr&aacute;.
            </p>
            <p>
                &THORN;&aacute; er einnig vakin athygli &aacute; verklagsreglum P&oacute;st- og
                fjarskiptastofnunar &thorn;ar sem m.a. er fjalla&eth; um r&eacute;tt notanda til
                a&eth; vera &oacute;skr&aacute;&eth;ur &iacute; gagnagrunn n&uacute;mera- og
                vistfangaskr&aacute; og bann vi&eth; birtingu kennit&ouml;lu nema me&eth;
                sam&thorn;ykki notanda.
            </p>
            <p>
                Vinnslua&eth;ilar f&aacute; a&eth;gang a&eth; nau&eth;synlegum uppl&yacute;singum
                skv. vinnslusamningi. 1819 mi&eth;lar einnig &aacute;fram skr&aacute;ningum
                einstaklinga &aacute; mi&eth;lum 1819 &iacute; gegnum API &thorn;j&oacute;nustu
                e&eth;a kaup &aacute; einstaka listum til a&eth;ila sem kaupa &thorn;&aacute;
                &thorn;j&oacute;nustu, er ger&eth;ur vinnslusamningur &iacute; hvert skipti sem er
                &iacute; samr&aelig;mi vi&eth; &ouml;ryggisstefnu 1819.
            </p>
            <p>
                <strong>Notkun &aacute; 1819.is</strong>
            </p>
            <p>
                1819 vekur athygli &aacute; &thorn;v&iacute; a&eth; &thorn;egar fari&eth; er inn
                &aacute; heimas&iacute;&eth;u 1819 vistast svokalla&eth;ar k&ouml;kur (e. Cookies)
                &iacute; t&ouml;lvu notanda. K&ouml;kur eru litlar textaskr&aacute;r sem eru
                nota&eth;ar til &thorn;ess a&eth; greina heims&oacute;knir &aacute;
                vefs&iacute;&eth;u eftir IP-t&ouml;lum. A&eth;rar vefs&iacute;&eth;ur geta ekki
                lesi&eth; uppl&yacute;singar sem geymdar eru &iacute; k&ouml;kunni.
            </p>
            <p>
                Uppl&yacute;singar sem veri&eth; er a&eth; safna af vef 1819 um notendur eru
                nota&eth;ar til &thorn;ess a&eth; afla vitneskju um notkun &aacute; vefnum og
                hva&eth;a efni notendur hafa &aacute;huga &aacute;. &THORN;annig er h&aelig;gt
                a&eth; b&aelig;ta &thorn;j&oacute;nustu 1819.is og a&eth;laga vefinn betur a&eth;
                &thorn;&ouml;rfum notenda.
            </p>
            <p>
                H&aelig;gt er a&eth; breyta &ouml;ryggisstillingum &aacute; flestum v&ouml;frum
                &thorn;annig a&eth; &thorn;eir taki ekki &aacute; m&oacute;ti k&ouml;kum. Einnig er
                h&aelig;gt a&eth; ey&eth;a k&ouml;kum me&eth; einf&ouml;ldum h&aelig;tti.
                N&aacute;nari uppl&yacute;singar um hvernig &thorn;a&eth; er gert m&aacute; finna
                &aacute; heimas&iacute;&eth;um flestra vafra.
            </p>
            <p>
                N&aacute;nari uppl&yacute;singar m&aacute; finna &iacute;
                pers&oacute;nuverndarstefnu 1819.
            </p>
        </InfoSection>
    );
}
export default ServiceNumber;
